import { render, staticRenderFns } from "./b2b-table-card-row.vue?vue&type=template&id=2c6581f6&functional=true"
import script from "./b2b-table-card-row.vue?vue&type=script&lang=js"
export * from "./b2b-table-card-row.vue?vue&type=script&lang=js"
import style0 from "./b2b-table-card-row.vue?vue&type=style&index=0&id=2c6581f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports